import * as React from 'react';
import { Route, useHistory, useLocation } from 'react-router';

import NavMenu from '../components/NavMenu';
// import AdminDashboard from '../components/AdminDashboard';
import AdminDashboard from '../presentations/view/AdminDashboard/AdminDashboard.view';
import Home from '../components/Home';
import Counter from '../components/Counter';
import AdminDashboardWeb from '../components/AdminDashboardWeb';
import AdminDashboardOverView from '../components/AdminDashboardOverView';
import ViewDashboard from '../components/ViewDashboard/ViewDashboard';
import ViewDashboardServer from '../components/ViewDashboard/ViewDashboardServer';
import DashboardServerDetail from '../presentations/view/DashboardServerDetail/DashboardServerDetail.view';
import ManageAdminDashboard from '../components/ManageAdminDashboard';
import AdminDashboardApplicationServer from '../components/AdminDashboardApplicationServer';
// import AdminDashboardControl from '../components/AdminDashboard/AdminDashboardControl';
import AdminDashboardControl from '../presentations/view/AdminDashboardControl/AdminDashboardControl.view';
// import UpdateLog from '../components/UpdateLog/UpdateLog';
import Ingress from '../components/Ingress/Ingress';
import TopNavigation from 'components/TopNavigation/TopNavigation';
import MonitoringSummaryPDF from 'presentations/view/MonitoringSummaryPDF/MonitoringSummaryPDF.view';
// import F1ApiLogView from 'presentations/view/F1ApiLog/F1ApiLog.view';
import ServerMonitorView from '../presentations/view/ServerMonitor/ServerMonitor.view';
// import PortConfigView from 'presentations/view/PortConfig/PortConfig.view';
import F1ApiPortalView from 'presentations/view/F1ApiPortal/F1ApiPortal.view';
import TeamCalendarManageView from 'presentations/view/TeamCalendar/TeamCalendarManage.view';
import TeamCalendarPublicView from 'presentations/view/TeamCalendar/TeamCalendarPublic.view';

export default (props: { children?: React.ReactNode }) => {
    const location = useLocation();
    const history = useHistory();
    const isPublicCalendarRoute = location.pathname.startsWith('/calendar/view/');
    const isCalendarRoute =
        location.pathname.startsWith('/teamcalendar') ||
        location.pathname.startsWith('/calendar/manage') ||
        isPublicCalendarRoute;

    React.useEffect(() => {
        const groupSession = sessionStorage.getItem('GROUP');
        const tokenSession = sessionStorage.getItem('MM_APPLICATION');

        const hasSessionValues = groupSession && tokenSession;

        if (
            hasSessionValues &&
            !location.pathname.includes('server-monitor') &&
            !isCalendarRoute
        ) {
            history.replace({
                pathname: '/server-monitor',
                search: new URLSearchParams({
                    group: groupSession,
                    token: tokenSession
                }).toString()
            });
        }
    }, [location, history]);

    return (
        <React.Fragment>
            {/* <NavMenu /> */}
            {!isPublicCalendarRoute && <TopNavigation />}
            <div className={isPublicCalendarRoute ? 'flex min-h-screen flex-col p-0' : 'container-fluid flex flex-1 flex-col p-0'}>
                <Route
                    exact
                    path="/"
                    component={AdminDashboard}
                />
                <Route
                    path="/summary"
                    component={MonitoringSummaryPDF}
                />
                <Route
                    path="/home"
                    component={Home}
                />
                <Route
                    path="/counter"
                    component={Counter}
                />
                <Route
                    path="/web"
                    component={AdminDashboardWeb}
                />
                <Route
                    path="/sever"
                    component={AdminDashboard}
                />
                <Route exact path="/admindashboard" component={AdminDashboard} />

                {/* AdminDashboard Menu Routes */}
                <Route path="/server" component={AdminDashboard} />
                <Route path="/dbworker" component={AdminDashboard} />
                <Route path="/dbcomparison" component={AdminDashboard} />
                <Route path="/updatelog" component={AdminDashboard} />
                <Route path="/cleartransaction" component={AdminDashboard} />
                <Route path="/migration" component={AdminDashboard} />
                <Route path="/transportuat" component={AdminDashboard} />
                <Route path="/transportprd" component={AdminDashboard} />
                <Route path="/monitorperformance" component={AdminDashboard} />
                <Route path="/f1apilog" component={AdminDashboard} />
                <Route path="/webmonitor" component={AdminDashboard} />
                <Route path="/fapp" component={AdminDashboard} />
                <Route path="/sftp" component={AdminDashboard} />
                <Route path="/portconfig" component={AdminDashboard} />
                <Route path="/monitorsizetable" component={AdminDashboard} />
                <Route path="/migrationscript" component={AdminDashboard} />
                <Route path="/dmsdashboard" component={AdminDashboard} />
                <Route path="/workflowdashboard" component={AdminDashboard} />
                <Route path="/newmigration" component={AdminDashboard} />
                <Route path="/workflowwaitingtime" component={AdminDashboard} />
                <Route path="/f1apiportal" component={AdminDashboard} />

                {/* Other Routes */}
                <Route path="/admindashboardoverview" component={AdminDashboardOverView} />
                <Route path="/viewdashboard/:page?/:id?" component={ViewDashboard} />
                {/* <Route path="/ViewDashboardServer/:page?/:id?" component={ViewDashboardServer} /> */}
                <Route path="/ViewDashboardServer/:page?/:id?" component={DashboardServerDetail} />
                <Route path="/manageadmindashboard/:page?/:id?" component={ManageAdminDashboard} />
                <Route path="/adminApplicationServer" component={AdminDashboardApplicationServer} />
                <Route path="/admindashboardcontrol/:id?" component={AdminDashboardControl} />
                <Route path="/ingress" component={Ingress} />
                <Route path="/server-monitor" component={ServerMonitorView} />
                <Route exact path="/teamcalendar" component={TeamCalendarManageView} />
                <Route exact path="/calendar/manage" component={TeamCalendarManageView} />
                <Route path="/calendar/view/:shareToken" component={TeamCalendarPublicView} />
            </div>
        </React.Fragment>
    );
};
